import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 图片预览弹窗组件
 * @author 严俊华
 */
import { Modal } from 'antd';
//工具
import { isEmpty } from 'lodash';
//css
import styles from './index.module.less';
//常量
const AntModal = Modal;
const ReviewModal = ({ visible = false, previewImage = '', previewVideo = '', onCancel = () => { }, }) => {
    return (_jsxs(AntModal, { visible: visible, footer: null, onCancel: onCancel, className: styles.reviewModal, children: [!isEmpty(previewImage) ? (_jsx("img", { className: styles.image, src: previewImage })) : null, !isEmpty(previewVideo) ? (_jsx("video", { className: styles.previewVideo, src: previewVideo, autoPlay: true, controls: true })) : null] }));
};
export default ReviewModal;
